import moment from "moment-timezone";
import { mapGetters } from "vuex"
import common from '@/views/game-lobby/mixins/common.js'
import siteGroup from 'utils/site-group.js'
export default {
  mixins: [common],
  data () {
    return {
      searchDate: [moment().format(), moment().format()],
      apiData: [],
      nowSite: 999,
      nowSeries: 0,
      nowGame: 0,
      dateBtns: [
        { id: 1, name: '今日' },
        { id: 2, name: '昨天' },
        { id: 3, name: '本周' },
        { id: 4, name: '上周' },
        { id: 5, name: '本月' },
        { id: 6, name: '上月' }
      ]
    }
  },
  computed: {
    ...mapGetters(["getAllGame"]),
    filterGame () {
      if (!this.getAllGame.length) return []
      let gameData = this.getAllGame.filter((item, index) => item.ismy == 1 && item.gameGroupId != 11)
        .filter(it => {
          if (this.nowSite !== 999 && this.nowSeries) {
            return (it.siteId == this.nowSite && it.catenaId == this.nowSeries)
          } else if (this.nowSeries) {
            return it.catenaId == this.nowSeries
          } else if (this.nowSite !== 999) {
            return it.siteId == this.nowSite
          } else {
            return it
          }
        })
      gameData.unshift({
        catenaId: 0,
        gameGroupId: 0,
        gameid: 0,
        gamename: "全部",
        ismy: 0,
        siteId: 0
      })
      return gameData
    },
    siteAllList () {
      return siteGroup.allSelect()
    }
  },
  watch: {
    nowSite () {
      if (this.nowGame == 0) this.search()
      this.nowGame = 0
    },
    nowSeries () {
      if (this.nowGame == 0) this.search()
      this.nowGame = 0
    },
    nowGame () {
      this.search()
    }
  },
  methods: {
    setDate (id) {
      switch (id) {
        case 1:
          let today = moment();
          this.searchDate = [today, today];
          break;
        case 2:
          let yesterday = moment(new Date()).add(-1, 'days');
          this.searchDate = [yesterday, yesterday];
          break;
        case 3:
          let day1 = moment().startOf('isoweek')
          let day7 = moment().endOf('isoweek')
          this.searchDate = [day1, day7];
          break;
        case 4:
          let upday1 = moment().startOf('isoweek').subtract('isoweek', 1); // 周一日期
          let upday7 = moment().endOf('isoweek').subtract('isoweek', 1); // 周日日期
          this.searchDate = [upday1, upday7];
          break;
        case 5:
          let month1 = moment().startOf('month')
          let month2 = moment().endOf('month')
          this.searchDate = [month1, month2];
          break;
        case 6:
          let upmonth1 = moment().subtract(1, 'months').startOf('month')
          let upmonth2 = moment().subtract(1, 'months').endOf('month')
          this.searchDate = [upmonth1, upmonth2];
          break;
      }
    },
  }
}